<template>
  <div class="py-2 relative">
    <div class="block text-xss text-gray-700 ">{{ label }}</div>
    <div @click="isOpen = !isOpen"
      class="flex items-center pl-2 border h-[41px] sm:text-xss border-gray-300 rounded-md bg-white py-0.5">
      <div class="w-full">
        {{ selectedDepartments.length }} selecionados
      </div>
      <div class="p-2 text-xs">▼</div>
    </div>
    <div class="relative z-10">
      
      <div v-if="isOpen" class="absolute text-xs rounded-b-lg bg-white h-[200px] w-full  overflow-y-auto border">
        <div v-if="dataRows.length > 0">
          <div v-for="department in dataRows" :key="department.id" class="flex gap-2 items-center  hover:bg-slate-600 p-2 hover:text-white" :style="{ marginLeft: department.nivel * 15 + 'px' }">
            <input type="checkbox" :id="department.id" :value="department" :checked="isChecked(department)" @change="onDepartmentSelect(department)" />

            <label :for="department.id">{{ department.name }}</label>
          </div>
        </div>
        <div v-else class=" w-full h-full flex items-center justify-center text-xs ">
          Nenhum departamento
        </div>
      </div>
    </div>
    <div v-if="selectedDepartments.length" class="flex flex-wrap gap-2 pt-2">
      <div v-for="department in selectedDepartments" :key="department.id"
        class="bg-gray-200  p-1 rounded px-2 text-xs flex items-center gap-1 px-1 ">
        <div class="p-1">
          {{ department.name }}
        </div>
        <div>
          <XMarkIcon class="w-4 h-4" @click.stop="removeDepartment(department)" />
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import { XMarkIcon } from "@heroicons/vue/24/outline";

export default {
  name: "SelectorDepartaments",
  props: {
    label: {
      type: String,
      required: true,
    },
    departments: {
      type: Array,
      default: () => [],
    },
    departmentsSelected: {
      type: [Array, String],
      default: () => [],
    },
    settings_workspaces_id: String,
  },

  components: {
    XMarkIcon,
  },
  data() {
    return {
      urlDepartaments: "core/components/fields/departaments",
      isOpen: false,
      selectedDepartments: [],
      dataRows: [],
      params: {
        settings_workspaces_id: this.settings_workspaces_id,
        search: "",
        page: 1,
      },
    };
  },

  computed: {
    selectedDepartmentsDisplay() {
      return this.selectedDepartments.length
        ? `${this.selectedDepartments.length} selecionado(s)`
        : "Selecione os departamentos";
    },
  },

  methods: {

    isChecked(department) {
        return this.selectedDepartments.some(dept => dept.id === department.id);
    },    
    onDepartmentSelect(department) {
        const index = this.selectedDepartments.findIndex(d => d.id === department.id);
        if (index === -1) {
            this.selectedDepartments.push(department);
        } else {
            this.selectedDepartments.splice(index, 1);
        }
        this.$emit("update:selectedDepartments", this.selectedDepartments);
    },
    removeDepartment(department) {
      const index = this.selectedDepartments.findIndex((selected) => selected.id === department.id);
      if (index !== -1) {
        this.selectedDepartments.splice(index, 1);
        this.$emit("update:selectedDepartments", this.selectedDepartments);
      }
    },
    getDepartaments() {
      this.$ApiService.post(this.urlDepartaments, this.params).then((response) => {
        this.dataRows = this.$DepartamentsFunctions.organizeDeptos(response.data);

        // Remove departamentos com nome de spam seja maiusculo ou minusculo
        this.dataRows = this.dataRows.filter((department) => department.name.toLowerCase() !== "spam");              

      });
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  async created() {
    if (!this.departments.length && this.settings_workspaces_id) {
      await this.getDepartaments();
    } else {
      this.dataRows = this.departments;
    }

    // se for string separa por virgula
    if (typeof this.departmentsSelected === "string") {
      //this.selectedDepartments = this.departmentsSelected.split(",").map((id) => ({ id: parseInt(id) }));
    } else {
      this.selectedDepartments = this.departmentsSelected;
    }

  },
  watch: {
    settings_workspaces_id() {
      if (!this.departments.length && this.settings_workspaces_id) {
        this.selectedDepartments = [];
        this.params = {
          settings_workspaces_id: this.settings_workspaces_id,
          search: "",
          page: 1,
        };
        this.getDepartaments();
      }
    },
  },

  async created() {
      if (!this.departments.length && this.settings_workspaces_id) {
          await this.getDepartaments();
      } else {
          this.dataRows = this.departments;
      }
      if (typeof this.departmentsSelected === "string") {
          this.selectedDepartments = this.departmentsSelected.split(",").map(id => {
              return this.dataRows.find(dept => dept.id === parseInt(id));
          });
      } else {
          this.selectedDepartments = this.departmentsSelected;
      }
  }

};
</script>